import script from "./PodcastersList.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastersList.vue?vue&type=script&setup=true&lang=js"

import "./PodcastersList.vue?vue&type=style&index=0&id=271e0434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-271e0434"]])

export default __exports__